import React, { Component } from 'react'
import BoardItem from '../component/BoardItem'
import { Table, Divider, Form,Input,Modal, Button } from 'antd'
import './style.less'

class merchants extends Component {
    state = {
        loading: false,
        visible: false,
    }

    showModal = () => {
        this.setState({
            visible: true,
        })
    }

    handleOk = () => {
        this.setState({ loading: true })
        setTimeout(() => {
            this.setState({ loading: false, visible: false })
        }, 3000)
    }

    handleCancel = () => {
        this.setState({ visible: false })
    }

    render () {
        const data = [
            {
                key: '1',
                name: 'John Brown',
                age: 32,
                address: 'New York No. 1 Lake Park',
            },
            {
                key: '2',
                name: 'Jim Green',
                age: 42,
                address: 'London No. 1 Lake Park',
            },
            {
                key: '3',
                name: 'Joe Black',
                age: 32,
                address: 'Sidney No. 1 Lake Park',
            },
        ]
        const columns = [
            {
                title: '订单号',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '交易金额',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '交易时间',
                dataIndex: 'address',
                key: 'address',
            },

            {
                title: '资金状态',
                key: 'action',
                render: (text, record) => (
                    <span>
                        <a href="javascript:">Invite {record.name}</a>
                        <Divider type="vertical" />
                        <a href="javascript:">Delete</a>
                    </span>
                ),
            },
        ]
        const { visible, loading } = this.state
        const { getFieldDecorator } = this.props.form
        return (
            <div className='merchants-page'>
                <div className='board'>
                    <BoardItem icon='pay-circle' itemKey='余额' itemValue='5000' clickCallBack={this.showModal} buttonLabel='充值' />
                    <BoardItem icon='money-collect' itemKey='冻结余额' itemValue='5000' />
                    <BoardItem icon='line-chart' itemKey='有效订单' itemValue='5000' />
                    <BoardItem icon='disconnect' itemKey='冻结订单' itemValue='5000' />
                </div>
                <div className='tablecontain'>
                    <Table bordered columns={columns} dataSource={data} />
                </div>
                <Modal
                    visible={visible}
                    title="提现"
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}> 取消 </Button>,
                        <Button key="submit" type="primary" loading={loading} onClick={this.handleOk}>确定</Button>,
                    ]}
                >
                    <Form className="modal-form">
                        <Form.Item label="提现金额" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                            {getFieldDecorator('code', {
                                rules: [{ required: true, message: '请输入提现金额' }],
                            })(
                                <Input placeholder="请输入提现金额" />,
                            )}
                        </Form.Item>
                        <Form.Item label="银行卡" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                            {getFieldDecorator('name', {
                                rules: [{ required: true, message: '请输入银行卡' }],
                            })(
                                <Input placeholder="请输入银行卡" />,
                            )}
                        </Form.Item>
                    </Form>
                </Modal>

            </div>
        )
    }
}

export default Form.create({ name: 'post_data' })(merchants)